import React, { useState } from "react";
import { Dialog, Divider, InputAdornment, MenuItem, Popover, TextField } from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroller";
import { P_Props } from "./SolutionList.type";
import { CategoryCard1, FloatingButton, Loading, Notification, Pulse } from "../../../../components";
import moment from "moment";
import { CategoryForm, SolutionForm } from "../../..";
import { PriorityHigh as PriorityHighIcon, Search, InfoOutlined, Edit, Delete } from "@material-ui/icons";
import CustomButton from "../../../../components/CustomButton";
import { DeleteIcon, EditIcon, PostSubIcon, ProductIcon } from "../../../../icons";
import { ImageUtil } from "../../../../../utils";
import { BlogCategoryApiOutputModel } from "../../../../../models";
import { CATEGORY_TYPES } from "../../../../../constants";

const SolutionListingPresenter: React.FC<P_Props> = (props) => {
  const [visibleWarning, setVisibleWarning] = useState<boolean>(false);
  const [visibleFloatingBtn, setVisibleFloatingBtn] = useState<boolean>(false);
  const [categoryDetele, setCategoryDetele] = useState<BlogCategoryApiOutputModel | undefined>();
  const [visibleDeleteCategoryModal, setVisibleDeleteCategoryModal] = useState<boolean>(false);
  const [categoryPopup, setCategoryPopup] = React.useState<{
    anchorEl: HTMLButtonElement | null;
    category: BlogCategoryApiOutputModel | null;
  }>({ anchorEl: null, category: null });

  const [visibleDeleteBlogModal, setVisibleDeleteBlogModal] = React.useState<{
    visible: boolean;
    code: string | null;
    title: string | null;
  }>({ visible: false, code: null, title: null });

  const toggleWarningModal = () => {
    setVisibleWarning(!visibleWarning);
  };
  console.log(props?.filter);

  const activeCategory = props.categories.find((cate) => cate.id === props.filter?.categoryUrl);

  const openCategoryPopup = (event: React.MouseEvent<HTMLButtonElement>, category: BlogCategoryApiOutputModel) => {
    setCategoryPopup({ anchorEl: event.currentTarget, category });
  };

  const toggleFloatingBtn = () => {
    setVisibleFloatingBtn(!visibleFloatingBtn);
  };

  const closeCategoryPopup = () => {
    setCategoryPopup({ anchorEl: null, category: null });
  };

  const toggleDeleteCategoryModal = (cate) => {
    if (cate) {
      setCategoryDetele(cate);
    }
    setVisibleDeleteCategoryModal(!visibleDeleteCategoryModal);
  };

  const toggleDeleteBlogModal = (code?: string, title?: string) => {
    code && title
      ? setVisibleDeleteBlogModal({ visible: true, code, title })
      : setVisibleDeleteBlogModal({ visible: false, code: null, title: null });
  };

  return (
    <>
      <div className="solution-listing">
        <div className="blog-listing__category">
          <div className="blog-listing__category__header">
            <div className="title">Category</div>
          </div>
          <div
            className={`blog-listing__category__item ${!activeCategory ? "active" : ""}`}
            onClick={() => {
              props.onChangeCategory("");
            }}
          >
            <div className="blog-listing__category__item__form">
              {/* <Avatar alt="All" src="/static/images/avatar/1.jpg">
                T
              </Avatar> */}
              <div className="blog-listing__category__item__name">All posts</div>
            </div>
          </div>
          <Divider style={{ width: "100%", margin: "1.6rem 0" }} />
          <div className="blog-listing__category__list">
            {props.categories.map((cate) => {
              console.log(cate);
              console.log(activeCategory);

              const isActive = cate.id === activeCategory?.id;

              return (
                <CategoryCard1
                  key={cate.id}
                  name={cate.title}
                  onClick={() => {
                    props.onChangeCategory(cate.id);
                  }}
                  selected={isActive}
                  onActionClick={(e) => {
                    openCategoryPopup(e, cate);
                  }}
                  buildPictureSrc={ImageUtil.buildBlogCategoryImgSrc}
                  isAvatar={true}
                />
              );
            })}
          </div>
        </div>
        <div className="solution-listing__content">
          <div className="solution-listing__content__header">
            <div className="solution-listing__content__header__title">Our Solution Pages</div>
            <div className="solution-listing__content__header__actions">
              <TextField
                placeholder="Search by name"
                variant="outlined"
                className="search-input"
                inputProps={{ className: "input" }}
                InputProps={{
                  // style: { fontSize: "1.4rem" },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search className="icon" />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  props.onSearch(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="solution-listing__content--note">
            <InfoOutlined style={{ marginRight: "0.5rem" }} />
            Maximum number of page: 10
          </div>
          <div className="solution-listing__content__list">
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={!props.fetchedSolution.loading && props.fetchedSolution.totalPages > props.fetchedSolution.page}
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedSolution.data.length) && props.fetchedSolution.loading && <Loading />}
              {props.fetchedSolution.data.map((page) => {
                return (
                  <div key={page.id} className="solution-listing__content__list__item">
                    <div
                      className="solution-text solution-listing__content__list__info"
                      onClick={() => {
                        props.openSolutionFormModal(page.code);
                      }}
                    >
                      <b>{page.title}</b>
                      <p className="solution-text solution-listing__content__list__createAt">
                        {moment(page.publishDate).format("DD/MM/YYYY, hh:mm a")}
                      </p>
                    </div>
                    <div className="solution-text solution-listing__content__list__control">
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          props.openSolutionFormModal(page.code);
                        }}
                        color={"transparent"}
                        item={
                        
                          <span>
                            <EditIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                         
                          
                        }
                      />
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDeleteBlogModal(page.code, page.title);
                        }}
                        color={"transparent"}
                        item={
                         
                          <span>
                            <DeleteIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                          
                        }
                      />
                    </div>
                  </div>
                );
              })}
              {Boolean(props.fetchedSolution.data.length) && props.fetchedSolution.loading && <Loading />}
            </InfiniteScroll>
          </div>
        </div>
      </div>

      <FloatingButton
        visible={visibleFloatingBtn}
        onClickPrimary={() => toggleFloatingBtn()}
        btns={[
          {
            color: "orange",
            title: "Post",
            icon: <PostSubIcon size={[24, 24]} color="white" />,
            onClick: (e) => {
              props.openSolutionFormModal();
            },
          },
          {
            color: "purple",
            title: "Category",
            icon: <ProductIcon size={[24, 24]} color="white" />,
            onClick: (e) => {
              props.openCategoryForm();
            },
          },
        ]}
      />

      <Dialog fullScreen open={props.visibleSolutionForm}>
        <SolutionForm
          // languageId={props.visibleSolutionId}
          solutionPageCode={props.visibleSolutionCode}
          onCancel={() => {
            props.closeSolutionFormModal();
          }}
          onComplete_Create={() => {
            props.closeSolutionFormModal();
            props.reloadListingPage();
          }}
          onComplete_Update={() => {
            props.closeSolutionFormModal();
            props.reloadListingPage();
          }}
          onComplete_Delete={() => {
            props.closeSolutionFormModal();
            props.reloadListingPage();
          }}
          categoryList={props?.categories}
        />
      </Dialog>
      <Dialog maxWidth="lg" fullWidth open={props.visibleCategoryForm}>
        <CategoryForm
          categoryType={CATEGORY_TYPES.SOLUTION}
          categoryCode={props.visibleCategoryId}
          onCancel={() => {
            props.closeCategoryForm();
            closeCategoryPopup();
          }}
          //initial={visibleCategoryForm.initData || undefined}
          onComplete_Create={() => {
            props.closeCategoryForm();
            props.reloadListingCatePage();
            closeCategoryPopup();
            toggleFloatingBtn();
          }}
          onComplete_Update={() => {
            props.closeCategoryForm();
            props.reloadListingCatePage();
            closeCategoryPopup();
          }}
          onComplete_Delete={() => {
            props.closeCategoryForm();
            props.reloadListingCatePage();
            closeCategoryPopup();
          }}
        />
      </Dialog>

      <Popover
        open={Boolean(categoryPopup.anchorEl)}
        anchorEl={categoryPopup.anchorEl}
        onClose={closeCategoryPopup}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          onClick={() => {
            props.openCategoryForm(categoryPopup.category?.code || undefined);
            closeCategoryPopup();
          }}
          style={{ fontSize: "1.4rem" }}
        >
          <Edit style={{ fontSize: "2.2rem", marginRight: "0.8rem" }} />
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            toggleDeleteCategoryModal(categoryPopup.category);
            closeCategoryPopup();
          }}
          style={{ color: "red", fontSize: "1.4rem" }}
        >
          <Delete style={{ fontSize: "2.2rem", marginRight: "0.8rem" }} />
          Delete
        </MenuItem>
      </Popover>

      {/* Warning Modal */}
      <Notification
        className="warning-modal"
        visible={visibleWarning}
        title="Maximum number of pages"
        subTitle="You have reached the maximum number of pages. You cannot create more page."
        icon={
          <Pulse color="yellow">
            <div className="notification-icon-box yellow">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button className="solution-listing__status-modal__actions__confirm" onClick={toggleWarningModal}>
              Ok
            </button>
          </>
        }
      />
      <Notification
        visible={visibleDeleteBlogModal.visible}
        title="Delete Post"
        subTitle={`Are you sure you want to delete “${visibleDeleteBlogModal.title}“ post? This action cannot be undone`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="blog-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteBlogModal();
              }}
            >
              Cancel
            </button>
            <button
              className="blog-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteBlogModal();
                props.onDeleteBlog(visibleDeleteBlogModal.code);
              }}
            >
              Confirm
            </button>
          </>
        }
      />

      <Notification
        visible={visibleDeleteCategoryModal}
        title="Delete Category"
        subTitle={`Are you sure you want to delete category “${categoryDetele?.title}“? This action cannot be undone`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="blog-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteCategoryModal(categoryDetele);
              }}
            >
              Cancel
            </button>
            <button
              className="blog-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteCategoryModal(categoryDetele);
                if (categoryDetele?.code) props.onDeleteCategory(categoryDetele?.code);
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default SolutionListingPresenter;
